import React from 'react'

// Lazy loading
import loadable from '@loadable/component'

interface BannerShellProps {
  // eslint-disable-next-line camelcase
  fields: GatsbyTypes.WpPost_Flexcontent_Flex_Banner
  location?: any
  pageContext?: any
}

interface BannersProps {
  [key: string]: any
}

const BannerShell: React.FC<BannerShellProps> = ({
  fields,
  location = {},
  pageContext,
}) => {
  const banners: BannersProps = {
    default: loadable(
      (): Promise<any> => import('components/flex/Banner/BannerDefault')
    ),
    home: loadable(
      (): Promise<any> => import('components/flex/Banner/BannerHome')
    ),
    content: loadable(
      (): Promise<any> => import('components/flex/Banner/BannerContent')
    ),
    detail: loadable(
      (): Promise<any> => import('components/flex/Banner/BannerDetail')
    ),
    cta: loadable(
      (): Promise<any> => import('components/flex/Banner/BannerCTA')
    ),
    contact: loadable(
      (): Promise<any> => import('components/flex/Banner/BannerContact')
    ),
  }

  if (!fields.styletype || !banners[fields.styletype]) {
    return null
  }

  const Component = banners[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
      pageContext={pageContext}
    />
  )
}

export default BannerShell
